'use es6';

import { getAggregationSupportedFieldTypes, getColumnField, getMeasures } from '../../utils/column-utils';
import { createConstraint, HARD, ILL_FORMED } from '../validate';
export const aggregations = createConstraint('supportedAggregationsForFieldTypes', HARD, ILL_FORMED, measures => measures.every(measure => getAggregationSupportedFieldTypes(measure).includes(getColumnField(measure).type)), report => getMeasures(report.columns));